import { connect } from 'react-redux';
import { setFilters } from 'feature/loading-management/filters/store/filtersSlice';

import CardTitle from './Title';

export default connect(null, { setFilters })(CardTitle);
